import { motion } from "framer-motion";

export default function PageTransition({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.2,
        ease: "easeOut",
      }}
      style={{
        minHeight: "100vh",
        background: "transparent",
      }}
    >
      {children}
    </motion.div>
  );
}
